import { useInfiniteQuery } from "@tanstack/react-query";
import { getTenantEntityAccessAudit } from "../api";

export function useTenantEntityAccessAudit(tenantId: string, enabled = true) {
  return useInfiniteQuery({
    queryKey: ["tenant-entity-access-audit", tenantId],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await getTenantEntityAccessAudit(
        tenantId,
        pageParam as number,
        20,
      );
      return {
        data: response.data,
        pagination: response.pagination,
        nextPage:
          pageParam < response.pagination.totalPages
            ? (pageParam as number) + 1
            : undefined,
      };
    },
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    enabled: enabled && !!tenantId,
  });
}
